module.exports = __webpack_public_path__ + "img/north-korea.2cf00f6f.svg";